<template>
    <nav aria-label="Page navigation" v-if="pagination.last_page > 1">

        <div class="d-flex justify-content-center mb-3">
            <input class="form-control col-1 form-control-sm" type="number" v-model="enteredPage" @keyup="getPage" @change="getPage"
                   placeholder="Goto Page" />
        </div>

        <ul class="pagination justify-content-center">

            <li class="page-item">
                <button class="page-link" aria-label="Previous" @click="changePage(1)">
                    {{Lang.get('pagination.first_page')}}
                </button>
            </li>

            <li class="page-item">
                <button class="page-link" aria-label="Previous" :title="Lang.get('pagination.previous')"
                        @click="changePage(pagination.current_page - 1)" :disabled="pagination.current_page <= 1">
                    <span aria-hidden="true">&laquo;</span>
                </button>
            </li>

            <li class="page-item" v-for="page in pages" :key="page" :class="{'active' : isCurrentPage(page)}">
                <button class="page-link" @click="changePage(page)">{{page}}</button>
            </li>

            <li class="page-item">
                <button class="page-link" aria-label="Next" :title="Lang.get('pagination.next')"
                        @click="changePage(pagination.current_page + 1)"
                        :disabled="pagination.current_page >= pagination.last_page">
                    <span aria-hidden="true">&raquo;</span>
                </button>
            </li>

            <li class="page-item">
                <button class="page-link" aria-label="Next" @click="changePage(pagination.last_page)">
                    {{Lang.get('pagination.last_page')}}
                </button>
            </li>

        </ul>

        <div class="text-center">
            <small>
                Total <strong>{{pagination.total}}</strong> records,
                showing from <strong>{{pagination.from}}</strong>
                to <strong>{{pagination.to}}</strong>
            </small>
        </div>

    </nav>
</template>

<script>
    export default {
        props: {
            pagination: {
                type: [Object, Array],
                required: true
            },

            offset: {
                type: Number,
                default: 5
            }
        },

        data() {
            return {
                enteredPage: '',
            }
        },

        methods: {
            isCurrentPage(page) {
                return this.pagination.current_page === page;
            },

            changePage(page) {
                if (page > this.pagination.last_page) {
                    page = this.pagination.last_page;
                }
                //this.pagination.current_page = page;
                this.$emit('paginate', page);
            },

            getPage() {
                if (_.isEmpty(this.enteredPage) || this.enteredPage <= 0 ||
                    this.enteredPage > this.pagination.last_page) {
                    return false;
                }

                this.changePage(this.enteredPage);
            },
        },

        computed: {
            pages() {
                let pages = [];
                let from = this.pagination.current_page - Math.floor(this.offset / 2);
                if (from < 1) {
                    from = 1;
                }
                let to = from + this.offset - 1;
                if (to > this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                while (from <= to) {
                    pages.push(from);
                    from++;
                }
                return pages;
            }
        }
    }
</script>

<style scoped>
    button:disabled {
        cursor: not-allowed;
    }
</style>
